import type { ExerciseDetails } from "@akina/domain";
import type { NullableCmsCopy } from "@akina/infra";
import { useCmsCopyStore } from "@akina/presentation";

export function findCmsExerciseDetails(
  exerciseTemplateKey: string | undefined,
  cmsCopy: NullableCmsCopy,
  getExerciseDetails: (key: string) => ExerciseDetails | undefined,
) {
  if (!exerciseTemplateKey || !cmsCopy) return undefined;

  return getExerciseDetails(exerciseTemplateKey);
}

export function useCmsExerciseDetails(exerciseTemplateKey: string | undefined) {
  const cmsCopy = useCmsCopyStore(state => state.cmsCopy);
  const getExerciseDetails = useCmsCopyStore(state => state.actions.getExerciseDetails);

  return findCmsExerciseDetails(exerciseTemplateKey, cmsCopy, getExerciseDetails);
}
